<template>
  <v-dialog v-model="myValue" persistent max-width="1200">
    <v-card>
      <v-card-title class="headline">余样</v-card-title>
      <v-card-text>
        <v-row v-if="list && list.length" no-gutters>
          <v-col cols="12">
            <v-row class="font-weight-black text-left py-4" no-gutters>
              <v-col cols="2">样本编号</v-col>
              <v-col cols="1">样本名称</v-col>
              <v-col cols="1">样本管标记名</v-col>
              <v-col cols="1">样本状态</v-col>
              <v-col cols="1">管数</v-col>
              <!--              <v-col cols="2">样本类型</v-col>-->
              <v-col cols="1" v-if="showCol('original')">原始样品</v-col>
              <v-col cols="1" v-if="showCol('protein')">蛋白质</v-col>
              <v-col cols="1" v-if="showCol('peptide')">肽段</v-col>
              <v-col cols="1" v-if="showCol('rna')">RNA</v-col>
              <v-col cols="1" v-if="showCol('dna')">DNA</v-col>
              <v-col cols="1">备注</v-col>
            </v-row>
          </v-col>
          <template v-for="(item, i) in list">
            <v-col :key="`divider_${i}`" cols="12"><v-divider /></v-col>
            <v-col
              cols="2"
              :key="`project_${i}`"
              class="caption py-4 text-left"
            >
              {{ item.samplecode }}
            </v-col>
            <v-col
              cols="1"
              :key="`project_${i}`"
              class="caption py-4 text-left"
            >
              {{ item.samplename }}
            </v-col>
            <v-col
              cols="1"
              :key="`project_${i}`"
              class="caption py-4 text-left"
            >
              {{ item.ypgbjm }}
            </v-col>
            <v-col
              cols="1"
              :key="`project_${i}`"
              class="caption py-4 text-left"
            >
              {{ item.samplestatus }}
            </v-col>
            <v-col
              cols="1"
              :key="`project_${i}`"
              class="caption py-4 text-left"
            >
              {{ item.num }}
            </v-col>
            <v-col
              cols="1"
              :key="`project_${i}`"
              class="caption py-4 text-left"
              v-if="showCol('original')"
            >
              {{ item.original }}
            </v-col>
            <v-col
              cols="1"
              :key="`project_${i}`"
              class="caption py-4 text-left"
              v-if="showCol('protein')"
            >
              {{ item.protein }}
            </v-col>
            <v-col
              cols="1"
              :key="`project_${i}`"
              class="caption py-4 text-left"
              v-if="showCol('peptide')"
            >
              {{ item.peptide }}
            </v-col>
            <v-col
              cols="1"
              :key="`project_${i}`"
              class="caption py-4 text-left"
              v-if="showCol('rna')"
            >
              {{ item.rna }}
            </v-col>
            <v-col
              cols="1"
              :key="`project_${i}`"
              class="caption py-4 text-left"
              v-if="showCol('dna')"
            >
              {{ item.dna }}
            </v-col>
            <v-col
              cols="1"
              :key="`project_${i}`"
              class="caption py-4 text-left"
            >
              {{ item.vnote }}
            </v-col>
          </template>
        </v-row>
        <v-row v-else style="margin-top: 50px" justify="center" no-gutters>
          <v-col cols="auto" class="text-h4 orange--text">暂无数据</v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="darken-1" @click="myValue = false">关闭</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { asgLtcSampleRemainList } from "@/plugins/api";

export default {
  components: {},
  props: {
    item: {
      type: Object,
      default() {
        return {};
      },
    },
    value: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    getList() {
      const params = {
        projectNo: this.myItem.projectcode,
      };
      asgLtcSampleRemainList(params).then(({ data }) => {
        this.list = data ?? [];
      });
    },
    //是否展示该列
    showCol(key) {
      return this.list?.find((item) => item[key]);
    },
  },
  data() {
    return {
      list: [],
    };
  },
  computed: {
    myItem() {
      return this.item;
    },
    myValue: {
      get() {
        if (this.value) {
          this.getList();
        }
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  created() {},
};
</script>
